module.exports = __webpack_public_path__ + "img/icons/video-9beaac443aeb0665fe1df6d943390a2a.svg";